module.exports = "/_next/static/images/img__consultation-boy_desktop-9debafca61792be2dfa833f2c9cc65d7.png";